<div class="list-page list-page--wide">
  <header class="page-header">
    <h1 class="page-header__title">Invitations</h1>
    <p class="page-header__subtitle">
      New quote requests or work assignments from CREtelligent — review the scope
      and submit your bid or accept the assignment.
    </p>
  </header>

  <div *ngIf="data?.length > 0; else placeholder">
    <ng-container *ngFor="let item of data; trackBy: trackByProjectId">
      <app-project-group
        [project]="item"
        [type]="'invitations'"
        [testIdProjectScope]="item.projectId"
        (atpSigned)="signedAtpSiteVisits = $event"
      ></app-project-group>
    </ng-container>
  </div>
  <ng-template #placeholder>
    <div *ngIf="loading; else notLoading" class="empty-state" data-testid="invitations-loading">
      <p class="empty-state__title">Loading invitations…</p>
    </div>
    <ng-template #notLoading>
      <div class="empty-state" data-testid="invitations-empty">
        <p class="empty-state__title">No invitations</p>
        <p class="empty-state__text">New invitations will appear here as they come in.</p>
      </div>
    </ng-template>
  </ng-template>
</div>

<allbids-submitted-dialog
  [active]="bidSubmittedActive"
  (modalClosed)="toggleCloseSubmittedAllBidsModal()"
  [ngClass]="{ 'documents-dialog--active': bidSubmittedActive }"
/>
<bidsubmitted-dialog
  [active]="singleBidSubmittedActive"
  (modalClosed)="toggleCloseSubmittedBidModal()"
  [ngClass]="{ 'documents-dialog--active': singleBidSubmittedActive }"
/>
<decline-success
  [batch]="declineBatch"
  [active]="declineSuccessActive"
  [address]="address"
  [isFixedPrice]="isFixedPrice"
  [isAtp]="isAtp"
  (modalClosed)="toggleCloseDeclineSuccessModal()"
  [ngClass]="{ 'documents-dialog--active': declineSuccessActive }"
/>
<accepted-offered-proposal-dialog
  [active]="isOfferAcceptedActive"
  [multiple]="isOfferAcceptedMultiple"
  (modalClosed)="toggleCloseOfferAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isOfferAcceptedActive }"
/>
<atp-sign-accepted-dialog
  [active]="isAtpSignAccepted"
  [address]="address"
  [modalHeaderTitle]="atpModalHeaderTitle"
  [modalBody]="atpModalBody"
  [dashboard]="false"
  [siteVisits]="signedAtpSiteVisits"
  (modalClosed)="toggleCloseAtpSignAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isAtpSignAccepted }"
/>
